import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { memo } from 'react';
import { DragIcon } from '~/assets/icons';

type ItemType = {
  id: UniqueIdentifier;
  data: any;
  index: number;
  render?: (data: any, index: number, onItemChange: any) => React.ReactNode;
  disabled?: boolean;
  onItemChange?: (data: any, index: number) => void;
};

const Item = (props: ItemType) => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.id,
    disabled: !!props?.disabled,
  });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box
      ref={setNodeRef}
      style={{
        transition,
        transform: CSS.Translate.toString(transform),
      }}
      className={clsx('flex items-center w-full', 'select-none', isDragging && 'opacity-50')}
    >
      <Box {...attributes} {...listeners} className='mt-[16px] mr-[10px] drag-icon-container'>
        <DragIcon className='w-[20px] h-[20px]' />
      </Box>

      {props?.render ? props?.render(props?.data, props.index, props.onItemChange) : props.data.name}
    </Box>
  );
};

export default memo(Item);
